import { theme } from '../../../theme/theme';

export const MGP_GAUGE_CHART_BASE_CONFIG = {
  chart: {
    type: 'solidgauge',
    width: 300,
    height: 200,
  },

  solidgauge: {
    innerRadius: '70%',
    radius: '100%',
  },

  title: null,

  pane: {
    center: ['50%', '85%'],
    size: '140%',
    startAngle: -90,
    endAngle: 90,
    background: {
      backgroundColor: '#eee',
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc',
    },
  },

  exporting: {
    enabled: false,
  },

  tooltip: {
    enabled: false,
  },

  yAxis: {
    min: 0,
    max: 100,
    stops: [
      [0, 'rgba(255, 255, 255, 0.6)'],
      [1, 'rgba(255, 255, 255, 0.6)'],
    ],
    lineWidth: 0,
    tickWidth: 0,
    minorTickInterval: null,
    tickAmount: 0,
    title: {
      y: -70,
    },
    labels: {
      enabled: false,
    },
  },

  plotOptions: {
    solidgauge: {
      dataLabels: {
        y: 5,
        borderWidth: 0,
        useHTML: true,
      },
    },
  },

  credits: {
    enabled: false,
  },
};

export const MGP_GAUGE_CHART_SERIES_OPTIONS = {
  dataLabels: {
    format:
      '<div style="text-align:center">' +
      `<span style="font-size:32px;color:${theme.colors.neutral['600']}">{y}%</span><br/>` +
      `<span style="font-size:12px;color:${theme.colors.neutral['500']}">Probability of Success</span>` +
      '</div>',
  },
  innerRadius: '70%',
  radius: '90%',
};
